import { createContext, useContext } from 'react';

interface CollapsibleCardContextValue {
    expanded: boolean;
    toggle: () => void;
}

const CollapsibleCardContext = createContext<CollapsibleCardContextValue | undefined>(undefined);

const useCollapsibleCard = (): CollapsibleCardContextValue => {
    const context = useContext(CollapsibleCardContext);
    if (!context) {
        throw new Error('useCollapsibleCard must be used within a CollapsibleCard');
    }
    return context;
};

export type { CollapsibleCardContextValue };
export { CollapsibleCardContext };
export { useCollapsibleCard };
